import tool from "../tools";
import { i18n } from './../../../../plugins/i18n.js'
export default {
  Rezervasyon() {
    return {
      pNR_No: 0,
      HedefKur:"",
      FaturaBilgileri: [],
      kayitTarihi: null,
      cariKod: {
        id: "",
        kod: null,
        isim: "",
        isimAra: ""
      },
      takipNo:"",
      rezVeren: "",
      masrafMerkezi: {
        id: "",
        kod: "",
        isim: "",
        isimAra: ""
      },
      anaTip: 0,
      ulke: null,
      vizeSorumlusu: {
        id: "",
        kod: "",
        isim: "",
        tip: 0,
        intField:null
      },
      karsiRezKod: "",
      pozisyonNo:"",
      turKod: "",
      acenteDepartman: {
        id: "",
        kod: null,
        isim: "",
        isimAra: ""
      },
      hizmetNo: "",
      referansKod: "",
      adresler: [],
      kalemler: [],
      odemeler: [],
      toplamTL: {
        satis: 0,
        alis: 0,
        komisyon: 0,
        iskonto: 0
      },
      opsiyonluMusteri: false,
      opsiyonTarihi: null,
      opsiyonSaati: null,
    }
  },
  Adres() {
    return {
      id: -1,
      kisiTip: 0,
      kisiSira: -1,
      yas: 0,
      profilId: 0,
      tcKimlikNo: "",
      uyeNo: "",
      adSoyad: "",
      adres: "",
      dogumTarihi: null,
      cinsiyet: "",
      telefon1: "",
      gsm: "",
      eMail: "",
      lastName:"",
      firstName:"",
    }
  },
  Cinsiyet() {
    return [{
        text: 'Erkek',
        value: 'E'
      },
      {
        text: 'Kadın',
        value: 'K'
      }
    ]
  },

  // KisiTip: [{
  //   Kod: 0,
  //   Aciklama: "Yetişkin"
  // }, {
  //   Kod: 1,
  //   Aciklama: "Çocuk 1"
  // }],



  IcDis: [{
      text: 'Yurtiçi',
      value: 0
    },
    {
      text: 'Yurtdışı',
      value: 1
    }, {
      text: 'Tümü',
      value: null
    }
  ],


  Opsiyon: [{
      text: 'Tümü',
      value: 0
    }, {
      text: 'Opsiyonlu',
      value: 1
    },
    {
      text: 'Opsiyonsuz',
      value: 2
    }
  ],

  Para() {
    return {
      paraBirimi: "TL",
      kur: 1,
      kurTarihi: null
    }
  },
  KalemBase() {
    return {
      islemRef: 0,
      saticiEntegrasyon: null,
      entTip: null, //bu alanlar farklı sistemlerden copere entegre edilecek alanlar için eklendi PaxDrive-HotelRunner vb.
      entId: null,
      donem1: null,
      donem2: null,
      faturaBilgileri:[],
      satis: {
        KDVOran: 0
      },
      alis: {
        KDVOran: 0
      },
      komisyon: {
        KDVOran: null,
        tutar: 0
      },
      acenteKomisyon: {
        paraBirimi: null,
        kur: 0,
        tutar: 0,
        KDVOran: 0
      },
      iskonto: {
        oran: 0,
        tutar: 0,
        iskontoSebebi: null,
      },
      odeyenTaraf: 1,
      aciklama: null,
      tedarikciAciklama: null,
      turOperatoru: {
        id: null,
        kod: null,
        isim: null,
        isimAra: null,
      },
      departman: {
        id: null,
        kod: null,
        isim: null,
        isimAra: null,
      },
      kdvID: {
        id: null,
        kod: null,
        isim: null,
        isimAra: null
      },
      kdvMuafiyetID: {
        id: null,
        kod: null,
        isim: null,
        isimAra: null
      },
      entegrasyonKodu: null,
      maliyetCariKod: {
        id: null,
        kod: null,
        isim: null,
        tip: null
      },
      saticiTip: 1,
      kisiSira: [],
      yet_Satis: 0,
      co1_Satis: 0,
      co2_Satis: 0,
      co3_Satis: 0,
      co4_Satis: 0,
      ekY_Satis: 0,
      yet_Alis: 0,
      co1_Alis: 0,
      co2_Alis: 0,
      co3_Alis: 0,
      co4_Alis: 0,
      ekY_Alis: 0,

      yet_KisiSayisi: 0,
      co1_KisiSayisi: 0,
      co2_KisiSayisi: 0,
      co3_KisiSayisi: 0,
      co4_KisiSayisi: 0,
      ekY_KisiSayisi: 0,

      satici: {
        id: null,
        kod: null,
        isim: null,
        tip: null,
        YurtIci_YurtDisi: null,
        KDV: 0,
      },
      alisPara: this.Para(),
      satisPara: this.Para(),
      komisyonPara: this.Para(),
      komisyonYuzdeTip: 0,
      komisyonYuzde: 0,
      komisyonTutar: 0,
      P_RP: 'P',
      masrafMerkezi: {
        id: null,
        kod: null,
        isim: null,
        tip: null
      },
    }
  },
  KalemKonsolosluk() {
    return {
        KalemDetay: {
        Tip: 'NONE',
        VizeCesidi: {
          id: null,
          kod: null,
          isim: null,
          tip: null,
          YurtIci_YurtDisi: null
        },
        VizeNo: null,
        DeadLine: null,
        KonsVerilisTarihi: null,
        KonsCikisTarihi: null,
        Durum: null,
        TeslimTipi: null,
        TeslimEden: null,
        TeslimAlan: null,
        TeslimTarihi: null,
        KargoIsmi: null,
        KargoFisNo: null,
        KargoTeslimEdilenSube: null,
        KargoTeslimEdilenTel: null,
        KargoTeslimEdilecekSube: null,
        KargoTeslimEdilecekTel: null,
        PspCocukVar: false,
        PspCocukVizeIstiyor: false,
        Cocuk1Kod: null,
        PspOfsTeslimAlan: null,
        PspOfsTeslimTarihi: null,
        PspMusTeslimEden: null,
        PspMusTeslimTarihi: null,
        PasaportTip: 0,
        PasaportNo: null,
        VerildigiYer: null,
        VerilisTarihi: null,
        BitisTarihi: null,
        VizeDurumu: 1,
        KonsTahCikisTarihi: null,
        AlisKDV: null,
        RandevuZamani: null,
        IstenenDonem1: null,
        IstenenDonem2: null,
        GirisTipi: '0',
        VizeSorumlusu: null,
        MailGonTarihi: null,
      },
    }
  },
  KalemSigorta() {
    return {
        KalemDetay: {
        Tip1: null,
        Tip2: null,
        PoliceNo: null,
        DeadLine: null,
        PoliceTarihi: null,

      },
    }
  },
  KalemDiger() {
    return {
        KalemDetay: {
        isAciklama: null,
        Satici: null,
        IsKodu: null,
        Bolge: null,
        Saat: null,
        DeadLine: null,
        PaketDisi: null
      },
    }
  },

  VizeGirisTipi() {
    return [{
        text: i18n.tc('Single-entry'),
        value: 0
      },
      {
        text: i18n.tc('Mutiple-entry'),
        value: 1
      },
      {
        text: 'Transit',
        value: 2
      },
      {
        text: i18n.tc('Two-entry'),
        value: 3
      }
    ]
  },

  TurTuru() {
    return [{
        text: '',
        value: 0
      },
      {
        text: 'Private',
        value: 1
      },
      {
        text: 'Regular',
        value: 2
      },
      {
        text: 'ShorexGroup',
        value: 3
      },
      {
        text: 'PrivateSatis',
        value: 4
      },
      {
        text: 'RegularSatis',
        value: 5
      }
    ]
  },

  OdemeYeni() {
    return {
      OdemeTarihi: null,
      OdemeTipi: 0,
      NakitBilgi: {
        KarsiCari: {
          Unvan2: null,
          Adres1: null,
          Adres2: null,
          VergiDairesi: null,
          VergiNo: null,
          TCKimlikNo: null,
          Ilce_Il: null,
          EfaturaKayitli: null,
          PerFirstName: null,
          PerFamilyName: null,
          EMail: null,
        },
        KarsiCariAciklama: null
      },
      KrediKartBilgi: {
        KarsiCari: {
          Unvan2: null,
          Adres1: null,
          Adres2: null,
          VergiDairesi: null,
          VergiNo: null,
          TCKimlikNo: null,
          Ilce_Il: null,
          EfaturaKayitli: null,
          PerFirstName: null,
          PerFamilyName: null,
          EMail: null,

        },
        KarsiCariAciklama: null,
        FirmaKrediKartli: false,
        KartNo: null,
        KartAdi: null,
        KartTipi: null,
        Banka: null,
        Taksit: 0,
        PosKodu: null,
        PosTaksit: null,
        PuanTutari: 0
      },
      HavaleBilgi: {
        Banka: null,
        Aciklama: null,
      },
      SanalPosBilgi: {
        KarsiCari: {
          Unvan2: null,
          Adres1: null,
          Adres2: null,
          VergiDairesi: null,
          VergiNo: null,
          TCKimlikNo: null,
          Ilce_Il: null,
          EfaturaKayitli: null,
          PerFirstName: null,
          PerFamilyName: null,
          EMail: null,
        },
        KarsiCariAciklama: null
      },
      Tutar: 0,
      ParaBirimi: 'TL',
      Kur: 1,
      OdemeIadesi: false,
      PNR_No: null,
      EvrakNo: null,
      Aciklama: null

    }
  },
  Odeme() {
    return {
      P_OdemeTipi: 3,
      P_SirketAdi: null,
      P_HesapKodu: null,
      P_Tarih: null,
      P_Evraktipi: null,
      P_b_hyolu: null,
      P_evrakno: null,
      P_faturano: null,
      P_Referans: null,
      P_Aciklama: null,
      P_Vade: null,
      P_DovizCinsi: null,
      P_DovizTutar: 0,
      P_Kur: 0,
      P_KarsiHesap: null,
      P_KarsiKebir: null,
      P_KarsiGrup: null,
      P_KarsiMuavin: null,
      P_Brut: 0,
      P_iskonto: 0,
      P_kdv: 0,
      P_CekSiraNo: null,
      P_CSTip: null,
      P_KayitTar: null,
      P_KayitKul: null,
      P_DuzeltTar: null,
      P_DuzeltKul: null,
      P_PNR_No: null,
      P_cruiseid: null,
      P_reserved1: null,
      P_faturatar: null,
      P_Ent: null,
      P_CoIslemRef: null,
      P_CoKrediKartNo: null,
      P_CoKrediKartTip: null,
      P_CoKrediKartKod: null,
      P_CoKrediKartBanka: null,
      P_CoKrediKartTaksit: null,
      P_CoKrediKartYuzde: 0,
      P_CoPNRDegisiklikNo: null,
      P_kdvoran: 0,
      P_poskod: null,
      P_bicdis: null,
      P_iadefatno: null,
      P_odemekod: null,
      P_CoIslemRefGenel: null,
      P_CoSirketNo: null,
      P_Masraf: null,
      P_taksitId: null,
      P_taksitref: null,
      P_Taksitposkod: null,
      P_bankakod: null,
      P_kotakod: null,
      P_Taksitkodlabel: null,
      P_KarsiCari: null,
      P_puantutar: 0,
      P_Karsievrak: null,
      P_Karsidvztip: null,
      P_Karsikur: 0,
      P_Karsidvztutar: 0,
      P_Karsiaciklama: null,
      P_HvAciklama: null,
      P_KrediKartNo: null,
    }
  },

  KisiAdres() {
    return {
      dialogShow: false,
      adres: this.Adres()
    }
  },



  PasaportIslemDurumu() {
    return [{
      text: i18n.tc('Was-delivered'),
      value: 0
    },
    {
      text: i18n.tc('At-Checkout-Preparation'),
      value: 1
    },
    {
      text: i18n.tc('at-the-consulate'),
      value: 2
    },
    {
      text: i18n.tc('At-checkout-transaction-ok'),
      value: 3
    }
  ]
  },


  VizeDurumu() {
    return [{
      text: i18n.tc('Visa-Issued'),
      value: 0
    },
    {
      text: i18n.tc('in-process'),
      value: 1
    },
    {
      text: i18n.tc('Missing-document'),
      value: 2
    },
    {
      text:  i18n.tc('Rejection-Return'),
      value: 3
    },
    {
      text:  i18n.tc('In-the-office'),
      value: 4
    }
  ]
  },




  VizeTipi() {
    return [{
        text: i18n.tc('None'),
        value: 0
      }, {
        text: 'USA',
        value: 1
      }, {
        text: 'Schengen',
        value: 2
      },
      {
        text: i18n.tc('individual'),
        value: 3
      },
      {
        text: i18n.tc('Special'),
        value: 4
      },

    ]
  },

  KisiTipToStr(tip) {
    if (tip == null) {
      tip = 0
    }

    return this.KisiTip[tip].Aciklama
  },

  OdeyenTarafGetir(tip) {


    if (tip == null) {
      tip = -1
    }

    return 'Ödeme ' + this.OdemeTipi[tip + 1].aciklama
  },

  PansiyonTipToStr(tip) {

    if (tip == null) {
      tip = 0
    }

    var varmi = this.Pansiyon.filter(function (el) {
      return el.kod == tip
    });
    if (varmi.length != 0) {
      return varmi.aciklama
    } else {
      return null
    }



  },

  SaticiTipToStr(tip) {
    return this.SaticiTip[tip - 1].Aciklama
  },


  KisiTip: [{
    Kod: 0,
    Aciklama: "Yetişkin"
  }, {
    Kod: 1,
    Aciklama: "Çocuk 1"
  }, {
    Kod: 2,
    Aciklama: "Çocuk 2"
  }, {
    Kod: 3,
    Aciklama: "Çocuk 3"
  }, {
    Kod: 4,
    Aciklama: "Çocuk 4"
  }, {
    Kod: 5,
    Aciklama: "Ek Yatak"
  }, ],

  SaticiTip: [{
      Aciklama: "Otel",
      Kod: 1
    },
    {
      Aciklama: "Arac",
      Kod: 2
    },
    {
      Aciklama: "Restaurant",
      Kod: 3
    },
    {
      Aciklama: "Acente",
      Kod: 4
    },
    {
      Aciklama: "RentACar",
      Kod: 5
    },
    {
      Aciklama: "Rehber",
      Kod: 6
    },
    {
      Aciklama: "Muze",
      Kod: 7
    },
    {
      Aciklama: "Charter",
      Kod: 8
    },
    {
      Aciklama: "Gemi",
      Kod: 9
    },
    {
      Aciklama: "Diger",
      Kod: 10
    },
    {
      Aciklama: "Vize",
      Kod: 11
    },
    {
      Aciklama: "TurOperatoru",
      Kod: 12
    },
    {
      Aciklama: "Konsolosluk",
      Kod: 13
    },
    {
      Aciklama: "Sigorta",
      Kod: 14
    },
    {
      Aciklama: "Feribot",
      Kod: 15
    },
    {
      Aciklama: "Golf",
      Kod: 16
    }
  ],

  saticiTipleriStr: [{
      id: 'Otel',
      text: 'Otel'
    },
    {
      id: 'Arac',
      text: 'Araç'
    },
    {
      id: 'Restaurant',
      text: 'Restaurant'
    },
    {
      id: 'Acente',
      text: 'Acente'
    },
    {
      id: 'RentACar',
      text: 'Ren A Car'
    },
    {
      id: 'Rehber',
      text: 'Rehber'
    },
    {
      id: 'Muze',
      text: 'Müze'
    },
    {
      id: 'Charter',
      text: 'Charter'
    },
    {
      id: 'Gemi',
      text: 'Gemi'
    },
    {
      id: 'Diger',
      text: 'Diğer'
    },
    {
      id: 'TurOperatoru',
      text: 'Tur Operatoru'
    },
    {
      id: 'Konsolosluk',
      text: 'Konsolosluk'
    },
    {
      id: 'Sigorta',
      text: 'Sigorta'
    },
    {
      id: 'Feribot',
      text: 'Feribot'
    },
    {
      id: 'Golf',
      text: 'Golf'
    },
  ],

  OdemeTipi: [{
      kod: -1,
      aciklama: ""
    },
    {
      kod: 0,
      aciklama: "Müşteri tarafından"
    },
    {
      kod: 1,
      aciklama: "Ekstralar hariç acentemiz tarafından"
    },
    {
      kod: 2,
      aciklama: "Acentemiz tarafından Full-Credit"
    },
    {
      kod: 3,
      aciklama: "Tur Operatörü Tarafından"
    },
  ],
  OdemeTipi: [{
      kod: -1,
      aciklama: ""
    },
    {
      kod: 0,
      aciklama: "Müşteri tarafından"
    },
    {
      kod: 1,
      aciklama: "Ekstralar hariç acentemiz tarafından"
    },
    {
      kod: 2,
      aciklama: "Acentemiz tarafından Full-Credit"
    },
    {
      kod: 3,
      aciklama: "Tur Operatörü Tarafından"
    },
  ],

  Pansiyon: [{
      kod: 0, //"OB",
      aciklama: "Only Bed"
    },
    {
      kod: 1, //"BB",
      aciklama: "Bed & Breakfast"
    },
    {
      kod: 2, //"HB",
      aciklama: "Half Board"
    },
    {
      kod: 3, //"FB",
      aciklama: "Full Board"
    },
    {
      kod: 6, //"AI",
      aciklama: "All Inclusive"
    },
    {
      kod: 7, //"UAI",
      aciklama: "Ultra All Inclusive"
    }



  ]


}